<template lang="html">
  <div class="avatar" @click="click">
    <v-image class="avatar-image" v-if="image" :src="image" ratio="1by1" />
    <v-text
      class="avatar-name"
      tag="p"
      v-if="name"
      v-html="name"
      :title="name"
    ></v-text>
    <v-text
      class="avatar-about text-center"
      tag="p"
      v-if="about"
      v-html="about"
      :title="about"
    ></v-text>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: ['image', 'name', 'about', 'type'],
  methods: {
    click() {
      this.$emit('click');
    },
  },
};
</script>

<style lang="scss">
.avatar {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: font(title);

  .avatar-image {
    width: 100px;
    border-radius: 50%;
    margin-bottom: 0.6em;
    border: 1px solid #eee;
  }
  .avatar-name {
    color: color(primary);
    margin: 0;
    line-height: 1.3em;
    font-size: 1.3em;
    font-weight: 300;
    font-family: font(title);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    max-width: 100%;
  }
  .avatar-about {
    margin: 0;
    color: gray(500);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    max-width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/parts/components/avatar.vue